import { createAsyncThunk } from '@reduxjs/toolkit';
import { 
  getJDList, 
  getJDById, 
  createJD, 
  updateJD, 
  deleteJD, 
  parseJDFile, 
  uploadJDFile, 
  generateJD, 
  generateScreeningQuestions 
} from '../../utils/jdAPI';

// Async thunks
export const getJDListAction = createAsyncThunk(
  'jds/getJDList',
  async ({ params = {}, clientId }, { rejectWithValue }) => {
    try {
      const result = await getJDList(params, clientId);
      if (result.success) {
        return result.data || [];
      } else {
        return rejectWithValue(result.message || 'Failed to fetch job descriptions');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch job descriptions');
    }
  }
);

export const getJDByIdAction = createAsyncThunk(
  'jds/getJDById',
  async ({ jdId, clientId }, { rejectWithValue }) => {
    try {
      const result = await getJDById(jdId, clientId);
      if (result.success) {
        return result.data;
      } else {
        return rejectWithValue(result.message || 'Failed to fetch job description');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch job description');
    }
  }
);

export const createJDAction = createAsyncThunk(
  'jds/createJD',
  async ({ jdData, clientId }, { rejectWithValue }) => {
    try {
      const result = await createJD(jdData, clientId);
      if (result.success) {
        return result.data;
      } else {
        return rejectWithValue(result.message || 'Failed to create job description');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to create job description');
    }
  }
);

export const updateJDAction = createAsyncThunk(
  'jds/updateJD',
  async ({ jdId, jdData, clientId }, { rejectWithValue }) => {
    try {
      const result = await updateJD(jdId, jdData, clientId);
      if (result.success) {
        return { jdId, data: result.data };
      } else {
        return rejectWithValue(result.message || 'Failed to update job description');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to update job description');
    }
  }
);

export const deleteJDAction = createAsyncThunk(
  'jds/deleteJD',
  async ({ jdId, clientId }, { rejectWithValue }) => {
    try {
      const result = await deleteJD(jdId, clientId);
      if (result.success) {
        return jdId;
      } else {
        return rejectWithValue(result.message || 'Failed to delete job description');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to delete job description');
    }
  }
);

export const parseJDFileAction = createAsyncThunk(
  'jds/parseJDFile',
  async ({ formData, clientId }, { rejectWithValue }) => {
    try {
      const result = await parseJDFile(formData, clientId);
      if (result.success) {
        return result.data;
      } else {
        return rejectWithValue(result.message || 'Failed to parse JD file');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to parse JD file');
    }
  }
);

export const uploadJDFileAction = createAsyncThunk(
  'jds/uploadJDFile',
  async ({ file, clientId }, { rejectWithValue }) => {
    try {
      const result = await uploadJDFile(file, clientId);
      if (result.success) {
        return result.data;
      } else {
        return rejectWithValue(result.message || 'Failed to upload JD file');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to upload JD file');
    }
  }
);

export const generateJDAction = createAsyncThunk(
  'jds/generateJD',
  async ({ promptData, clientId }, { rejectWithValue }) => {
    try {
      const result = await generateJD(promptData, clientId);
      if (result.success) {
        return result.data;
      } else {
        return rejectWithValue(result.message || 'Failed to generate job description');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to generate job description');
    }
  }
);

export const generateScreeningQuestionsAction = createAsyncThunk(
  'jds/generateScreeningQuestions',
  async ({ jdData, clientId }, { rejectWithValue }) => {
    try {
      const result = await generateScreeningQuestions(jdData, clientId);
      if (result.success) {
        return result.data;
      } else {
        return rejectWithValue(result.message || 'Failed to generate screening questions');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to generate screening questions');
    }
  }
);

export const setSelectedJDAction = createAsyncThunk(
  'jds/setSelectedJD',
  async ({ jdId, jdList }, { rejectWithValue }) => {
    try {
      const selectedJD = jdList.find(jd => jd.id === jdId || jd.jd_id === jdId);
      if (selectedJD) {
        return selectedJD;
      } else {
        return rejectWithValue('Job description not found');
      }
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to select job description');
    }
  }
);














































